import {
  LogoutOutlined,
  MenuOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { Dropdown, Grid, Space } from 'antd';
import { ReactComponent as LogoSvg } from 'assets/newlogo.svg';
import { Avatar } from 'components';
import { getAccessToken, useSessionContext } from 'features/auth';
import { useLogoutService } from 'features/auth/use-cases/logout';
import { useUserContext } from 'features/users';
import { getUserFullName } from 'features/users/utils';
import { useSideBar } from 'providers/side-bar-provider';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import {
  StyledDropdownIcon,
  StyledHeader,
  StyledLogoWrapper,
  StyledUserInfo,
  StyledUserMenuButton,
} from './header.styles';

const { useBreakpoint } = Grid;

export const Header = () => {
  const { collapsed, toggleCollapsed } = useSideBar();
  const { logOut } = useSessionContext();
  const { user }: any = useUserContext();

  const { t } = useTranslation();
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const avatarSize = 24;

  const token = getAccessToken();

  const handleLogout = () => {
    // logOut();
    const formData = {
      access_token: token || "",
      refresh_token: "",
      type: ""
    }
    mutate(formData, { onSuccess: () => logOut() })
  }

  const { mutate } = useLogoutService()

  const userHasAccessToSettings: any = user?.user_id != 107093;
  if (!user) return null;


  return (
    <StyledHeader className='app-header'>
      <Space
        role='button'
        aria-controls='sideBar'
        aria-expanded={!collapsed}
        onClick={toggleCollapsed}
        className='app-header-logo-wrapper'
        aria-label={t('sideBar.toggle')}
      >
        <MenuOutlined className='app-header-hamburger-mobile' />
        {/* <StyledLogoWrapper className='logo'>
          <LogoSvg title={t('li3ibLogo')} height={40} /> (sdsd)
        </StyledLogoWrapper> */}
        <StyledLogoWrapper className='logo' style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <LogoSvg title={t('li3ibLogo')} height={40} />
          <span style={{color:"#EE3D8A",fontSize:"20px"}}>Client</span>
        </StyledLogoWrapper>

      </Space>

      <Space className='app-header-user-wrapper'>
        <Dropdown
          menu={{
            items: [
              userHasAccessToSettings && {
                key: 'accountSettings',
                label: t('userMenu.accountSettings'),
                icon: <SettingOutlined />,
                onClick: () => navigate(ROUTES.ACCOUNT_SETTINGS),
              },
              {
                key: 'logout',
                label: t('userMenu.logOut'),
                icon: <LogoutOutlined />,
                onClick: handleLogout,
              },
            ],
          }}
          trigger={['click']}
          // required for keyboard accessibility, see: https://github.com/ant-design/ant-design/issues/21357
          getPopupContainer={(triggerNode) =>
            triggerNode.parentNode as HTMLElement
          }
        >
          <StyledUserMenuButton
            className='app-header-user'
            ghost
            $avatarSize={avatarSize}
            aria-label={t('userMenu.toggle')}
          >
            <Avatar size={avatarSize} className='app-header-avatar' />

            <Space className='app-header-space'>
              <StyledUserInfo ellipsis={{ tooltip: true }}>
                {getUserFullName(user)}
              </StyledUserInfo>
              <StyledUserInfo
                className='app-header-user-role'
                ellipsis={{ tooltip: true }}
              >
                {user.role as any}
              </StyledUserInfo>
            </Space>



            {screens.lg ? (
              <StyledDropdownIcon style={{ marginLeft: '15px' }} />
            ) : null}
          </StyledUserMenuButton>
        </Dropdown>
      </Space>
    </StyledHeader>
  );
};
